import React from 'react';
import { EtaState } from '../../store/EtaSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope} from '@fortawesome/free-regular-svg-icons';


const SiteInfo = (props: any) => {
    const activeClass = `badge ${props.data.Active === "Y" ? "badge-success" : "badge-warning"} border border-light`;
    const activeStr = props.data.Active == "Y" ? "Active" : "Inactive";
    return (
        <div className="row">
            <div className="col">
                <div className="siteInfoCard">
                    <div className="row m-0 mb-1">
                        <div className="col text-left w-50">{props.data.SiteCode} <span className={activeClass + " siteInfoBadgeFont"}>{activeStr}</span></div>
                        <div className="col text-right w-50 align-middle"><FontAwesomeIcon icon={faPhone}/> {props.data.Phone}</div>
                    </div>
                    <div className="row m-0 text-center">
                        <div className="col text-left w-50"><FontAwesomeIcon icon={faLocationDot} /> {props.data.Address}</div>
                        <div className="col text-right w-50"><FontAwesomeIcon icon={faEnvelope}/> {props.data.Email}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiteInfo;